import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOvalBoth = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 20,
	viewBox: "0 0 44 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 44,
			height: 20,
			rx: 10,
			fill: "#FF8A00",
			fillOpacity: .13
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 9.5C20.5 9.28906 20.4062 9.10156 20.2422 8.9375L14.2422 3.6875C14.1016 3.57031 13.9141 3.5 13.75 3.5C13.5859 3.5 13.3984 3.54688 13.2344 3.6875L7.23438 8.9375C7.07031 9.10156 7 9.28906 7 9.5C7 9.92188 7.32812 10.25 7.75 10.25H8.5V14.75C8.5 15.1719 8.82812 15.5 9.25 15.5H11.5C11.8984 15.5 12.25 15.1719 12.25 14.75V12.125C12.25 11.9375 12.4141 11.75 12.625 11.75H14.875C15.0625 11.75 15.25 11.9375 15.25 12.125V14.75C15.25 15.1719 15.5781 15.5 16 15.5H18.2266C18.6484 15.5 18.9766 15.1719 18.9766 14.75V10.25H19.75C20.1484 10.25 20.4766 9.92188 20.5 9.5Z",
			fill: "#FF8A00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.8284 9.28997L36.9994 9.29853L34.8106 7.19331L30.4508 3L28.9115 4.49761L31.7142 7.19331H24V9.29853H34.6683V9.28997H34.8284Z",
			fill: "#FF8A00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.1716 11.0069L24.0006 10.9983L26.1894 13.1036L30.5492 17.2969L32.0885 15.7993L29.2858 13.1036L37 13.1036L37 10.9983L26.3317 10.9983L26.3317 11.0069L26.1716 11.0069Z",
			fill: "#FF8A00"
		})
	]
});
const ForwardRef = forwardRef(SvgOvalBoth);
export { ForwardRef as ReactComponent };
